import { USE_AD } from 'config/env'

export default USE_AD
